import { IGetState, TCardId } from 'app/types/types';
import { Dispatch, ThunkAction } from 'app/types/actions';
import { IDriveDoc } from 'app/store/model/card/types/IDriveDoc';
import { uploadFiles } from '../effects/uploadFiles';
import { SegmentCardEvent, SegmentCardOptions, segmentTrackAction } from '../../../../../../../../middlewares/segment';
import { getIsChatViewActive } from '../../../../../../../../store/router/selectors/getIsChatViewActive';
import { SegmentCardSourceValue } from '../../../../../../../../middlewares/segment/trackEntities/cardEvents';

export const onUploadClick = (
    cardId: TCardId,
    onStart: () => void,
    onProgress: (percent: number) => void,
    onFinish: () => void,
    setAttachments: (docs: IDriveDoc[]) => void,
): ThunkAction => {
    const action = (
        dispatch: Dispatch,
        getState: IGetState
    ) => {
        dispatch(segmentTrackAction(SegmentCardEvent.COMMENT_ATTACHMENT_ADD_CLICKED, {
            name: SegmentCardOptions.SOURCE,
            value: getIsChatViewActive(getState()) ? SegmentCardSourceValue.CHAT : SegmentCardSourceValue.CARD,
        }));
        const input = document.createElement('input');
        input.type = 'file';
        input.multiple = true;

        input.onchange = (e: InputEvent) => {
            const target = e.target as HTMLInputElement;
            onStart();

            return dispatch(uploadFiles(cardId, Array.from(target.files), onProgress))
                .then((driveDocs: IDriveDoc[]) => {
                    setAttachments(driveDocs);
                    return driveDocs && driveDocs.length && driveDocs[0];
                })
                .finally(onFinish);
        }

        input.click();
    };
    return action;
};
